import React, { FC, ReactNode } from "react";
import { useMedia } from "react-use";

import { Header } from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Section } from "@/components/Section";
import { MEDIA_SIZE_SM } from "@/core/media";
import { Flex } from "@/eworkitComponents";

import "./_suggested-section.scss";

interface ISuggestedSectionProps {
  header: string;
  renderPagination?: () => ReactNode;
}

export const SuggestedSection: FC<ISuggestedSectionProps> = props => {
  const baseClassName = "suggested-section";

  const isSmallScreen = useMedia(MEDIA_SIZE_SM);

  return (
    <Section className={baseClassName} border={[true]} shadow="none" background="background-card" borderRadius>
      <Flex direction="column" innerMargin="md" margin={["md"]}>
        <Flex direction={isSmallScreen ? "column" : "row"} align="flex-start" justify="space-between" innerMargin="md">
          <Flex direction="row" align="center" innerMargin="sm">
            <Icon icon="binoculars" size="lg" color="info" />
            <Header size="xs" color="info" weight="bold">
              {props.header}
            </Header>
          </Flex>
          {props.renderPagination && props.renderPagination()}
        </Flex>

        {props.children}
      </Flex>
    </Section>
  );
};
